export default __webpack_public_path__ + "static/media/icon-ionic-ios-camera.d816bcfe.svg";